import React, { useRef, useState } from 'react';
import './LinearStatusBar.css';

interface LinearStatusBarProps {
	leftLabel: string;
	rightLabel: string;
	value: number;
	title: string;
	type?: string;
	allChargerIds?: string[];
	tooltipLabel?: string;
	rightLabelValue?: number;
	tooltipPercentage?: number;
	tooltipTotal?: number;
	totalValue?: number;
	totalChargers?: number;
}

const LinearStatusBar: React.FC<LinearStatusBarProps> = ({
	leftLabel,
	rightLabel,
	value,
	type,
	rightLabelValue = 0,
	totalValue = 0,
	totalChargers = 0,
  tooltipLabel
}) => {
	const barRef = useRef<HTMLDivElement>(null);
	const tooltipRef = useRef<HTMLDivElement>(null);

	const [showTooltip, setShowTooltip] = useState(false);
	const [tooltipX, setTooltipX] = useState(0);
	const [hoveredSection, setHoveredSection] = useState<'left' | 'right'>(
		'left',
	);

	const isZeroState = totalValue === 0 && rightLabelValue === 0;

	const displayTotal =
		type === 'Chargers' || type === 'Connectors' ? totalChargers : totalValue;

	const displayType = type === 'Operational Connectors' ? 'Connectors' : type;

	const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
	if (!barRef.current) return;

	const rect = barRef.current.getBoundingClientRect();
	const mouseX = e.clientX - rect.left;

	const tooltipWidth =
		tooltipRef.current?.offsetWidth ?? 0;

	const halfWidth = tooltipWidth / 2;

	const clampedCenterX = Math.max(
		halfWidth,
		Math.min(mouseX, rect.width - halfWidth),
	);

	setTooltipX(clampedCenterX);

	const greenWidthPx = (value / 100) * rect.width;
	setHoveredSection(mouseX <= greenWidthPx ? 'left' : 'right');
};






	return (
		<div className='linear-status-bar'>
			<div className='lsb-labels'>
				<span>{leftLabel}</span>
				<span>{rightLabel}</span>
			</div>

			<div
				ref={barRef}
				className='lsb-bar-container'
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				onMouseMove={handleMouseMove}
			>
				<div
					className={`lsb-left-bar ${isZeroState ? 'zero' : ''}`}
					style={{ width: `${value}%` }}
				/>

				<div
					className={`lsb-right-bar ${isZeroState ? 'zero' : ''}`}
					style={{ width: `${100 - value}%` }}
				/>

				<div className='lsb-thumb' style={{ left: `${value}%` }}>
					<div className={`lsb-thumb-inner ${isZeroState ? 'zero' : ''}`} />
				</div>
				{showTooltip && (
	<div
		ref={tooltipRef}
		className="lsb-tooltip"
		style={{
			left: tooltipX,
			transform: 'translateX(-50%)',
			maxWidth:'500px'
		}}
	>
		<div className="lsb-tooltip-title">
			{hoveredSection === 'left'
				? `${leftLabel} ${displayType}`
				: `${rightLabel} ${displayType}`}
		</div>

		<div className="lsb-tooltip-content">
			{hoveredSection === 'right'
				? `${totalValue - rightLabelValue} out of ${displayTotal} ${tooltipLabel}`
				: `${rightLabelValue} out of ${displayTotal} ${tooltipLabel}`}
		</div>

		<div className="lsb-tooltip-arrow" />
	</div>
)}



				
			</div>
		</div>
	);
};

export default LinearStatusBar;
